// src/utils/axios.js
import axios from 'axios';
import Constantes from './Constantes';

// TOMAMOS LA RUTA DE CONSTANTES PARA EVITAR CAMBIAR ARCHIVOS INDIVIDUALMENTE.
const { raizBack } = Constantes;
const instance = axios.create({
    baseURL: raizBack
});

export default instance;
